module.exports = __webpack_public_path__ + "src/assets/img/guest_laundry.2d5b45dd.jpg";